import { Component } from '@angular/core';
import { IAResponseModel } from '../../../../../shared/models/iauser-model';
import { Router } from '@angular/router';
import { ApiService } from '../../../../../shared/services/api.service';
import { AutofilliaService } from '../../../../../shared/services/autofillia.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import IAUserModel from '../../../../../shared/models/iauser-model';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from "@angular/forms";
import { catchError, of, interval, takeUntil } from 'rxjs';
import { ToastrService } from "ngx-toastr";
import { NgIf } from '@angular/common';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { CommonService } from '../../../../../shared/services/common.service';
import { Subject, switchMap, timer } from 'rxjs';


@Component({
  selector: 'app-viewiadetails',
  templateUrl: './viewiadetails.component.html',
  styleUrl: './viewiadetails.component.css'
})
export class ViewiadetailsComponent {
  maxDate: string = new Date().toISOString().split('T')[0];
  showFocusSector: boolean = false;
  isCheckedFocusSector: boolean = false;
  savedFocusSectorIds: any;
  sectorId: any;
  existingFocusSectorIds: string[] = [];
  form = new FormGroup({
    registrationId: new FormControl({ value: '', disabled: true }),
    iaUserName: new FormControl({ value: '', disabled: true }),
    email: new FormControl({ value: '', disabled: true }),
    nameOfOrganisation: new FormControl({ value: '', disabled: true }),
    addressOfOrganisation: new FormControl({ value: '', disabled: true }),
    contactNumber: new FormControl({ value: '', disabled: true }),
    mobileNumber: new FormControl({ value: '', disabled: true }),
    Intervention: new FormControl({ value: '', disabled: true }),
    InterestsId: new FormControl({ value: '', disabled: true }),
    focusSectorId: new FormControl({ value: '', disabled: true }),
    focusSectorName: new FormControl({ value: '', disabled: true }),
    SpocName: new FormControl({ value: '', disabled: true }),
    SpocDesignation: new FormControl({ value: '', disabled: true }),
    SpocEmail: new FormControl({ value: '', disabled: true }),
    SpocMobile: new FormControl({ value: '', disabled: true }),
    spocmobotp: new FormControl({ value: '', disabled: true }),
  });



  form2 = new FormGroup({
    bankName: new FormControl({ value: '', disabled: true }),
    accountNumber: new FormControl({ value: '', disabled: true }),
    ifscCode: new FormControl({ value: '', disabled: true }),
    cin: new FormControl({ value: '', disabled: true }),
    organisationPAN: new FormControl({ value: '', disabled: true }),
    dateOfIncorporation: new FormControl({ value: '', disabled: true }),
    gstNumber: new FormControl({ value: '', disabled: true }),
    personName: new FormControl({ value: '', disabled: true }),
    contactNumber: new FormControl({ value: '', disabled: true }),
    mobileNumber: new FormControl({ value: '', disabled: true }),
    email: new FormControl({ value: '', disabled: true }),
    designation: new FormControl({ value: '', disabled: true }),
    briefBackgroundIA: new FormControl({ value: '', disabled: true }),
    summaryScaleIA: new FormControl({ value: '', disabled: true }),
    iaLogoName: new FormControl({ value: '', disabled: true }),
    ialogoFile: new FormControl({ value: null, disabled: true }),
    iaLogoPath: new FormControl({ value: null, disabled: true }),
    storeFields: new FormArray([]), // Leave FormArray empty
    gstPercent: new FormControl({ value: '', disabled: true }),
    gstType: new FormControl({ value: '', disabled: true }),
  });
  IsProfileCompleted: boolean = false;//false
  public isSubmitted: boolean = false;
  filteredData: any;
  isButtonDisabled = false;
  focusSector: any[] = [];
  selectedFocusSector: string[] = [];
  selectedFocusSectorName: string[] = [];
  allFocusSectorIds: string[] = [];
  allFocusSectorNames: string[] = [];

  formData: any;
  name = sessionStorage.getItem('iaUserName');

  data: any[] = [];
  usr_obj!: IAUserModel;
  iaUserName = sessionStorage.getItem('iaUserName');
  RegistrationId: string = '';
  industryAssociationId = sessionStorage.getItem('iaid');
  usr_object!: IAResponseModel;

  isEditable: boolean = false;


  //Registration deatils to be viewed
  NameOfOrganisation: string = '';
  AddressOfOrganisation: string = '';
  IAUserName: string = '';
  Email: string = '';
  ContactNumber: string = '';
  MobileNumber: string = '';
  FocusSectorName: string = '';
  //FocusSectorName =[];

  //IA Organisation Information
  IndustryAssociationId: string = '';
  bankName: string = '';
  accountNumber: string = '';
  ifscCode: string = '';
  cin: string = '';
  organisationPAN: string = '';
  dateOfIncorporation: string = '';
  gstNumber: string = '';
  personName: string = '';
  contactNumber: string = '';
  mobileNumber: string = '';
  email: string = '';
  designation: string = '';
  briefBackgroundIA: string = '';
  summaryScaleIA: string = '';
  //IsProfileCompleted: string = '';
  //maxDate: any;
  ialogoFile: File | null = null;
  IalogoErrors: { typeError: boolean; sizeError: boolean } = { typeError: false, sizeError: false };
  maxSizeInMB = 2; // Set file size limit (2 MB in this case)
  ialogoUrl: string | null = null; // Store image URL
  iasigUrl: string | null = null; // Store image URL

  interests: any[] = [];
  interventions: any[] = [];
  filteredInterests: any[] = [];
  selectedPairs: {
    interventionId: any;
    interventionName: string,
    interestId: string,
    interestName: string
  }[] = [];
  //spocList: any[] = []; // Array to store records
  spocList: {
    spocName: string;
    spocDesignation: string,
    spocEmail: string,
    spocMobile: string,
    isEdited?: boolean;
  }[] = [];
  isButtonSpocMobileDisabled: boolean = false;
  mobileSpocOtpTimerRunning: boolean = false;
  mobileSpocOtpTimer: number = 300;
  countdown: number = 300; // 300-second countdown for resend OTP
  countdownDisplay: string | undefined;
  isResendButtonDisabled: boolean = true;
  editingIndex: number | null = null;
  isSpocOTPVerified: boolean = false; // Initially false
  resendSpocMobileOtpDisabled: boolean = true;
  mobileOtpSent: boolean = false;
  isVerifySpocMobileOtpButtonDisabled: boolean = true;
  mobileResendCount = 1;
  maxResendAttempts: number = 5;
  isButtonMobileDisabled: boolean = false;
  countdownSubject: Subject<void> = new Subject<void>();
  otpError: boolean = false;
  otpSuccess: boolean = false;
  isOTPVerified: boolean = true;
  selectedFocusSectorIds: {
    focusSectorName: string,
    focusSectorId: string,
  }[] = []; // To store previously selected focus sector IDs
  //focusSector: any[] = []; // To store the list of focus sectors

  userType = sessionStorage.getItem('UserType');

  constructor(private router: Router,
    private ia_serv: AutofilliaService,
    private common: CommonService,
    private apiService: ApiService,
    private toastr: ToastrService,
    private fb: FormBuilder) {

  }

  ngOnInit(): void {
    this.LoadDetails();    
    this.loadInterventions();
    this.loadInterests();
  }

  GetIaOrganisationalInformation(IndustryAssociationId: any) {
    this.apiService.getRequest(API_ENDPOINTS.IA.GETIAORGANISATIONINFORMATIONFORMSSIDC, { IndustryAssociationId: IndustryAssociationId }).subscribe(
      result => {
        if (result.status) {

          this.form2.patchValue(result.data);

          //this.data = result;
          if (result.data.isProfileCompleted) {
            this.IsProfileCompleted = true;
          }
          else {
            this.IsProfileCompleted = false;
          }
          this.ialogoUrl = result?.data?.iaLogoPathShow;
          this.iasigUrl = result?.data?.iaSigPathShow;

        }

      }

    )
  }

  LoadDetails() {
    debugger
    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETIAPROFILEBYID, { IAID: this.industryAssociationId }).subscribe(

      result => {
        if (result.status) {

          this.form.patchValue(result.list1[0]);

          this.form.patchValue(result.list2[0]);
          this.form2.patchValue(result.data);



          if (result.list2 && Array.isArray(result.list2)) {
            // Initialize savedFocusSectorIds as an empty array
            this.savedFocusSectorIds = [];

            // Accumulate focusSectorIds into the array
            result.list2.forEach((sector: any) => {


              //this.savedFocusSectorIds.push(sector.focusSectorId);
            });
            this.FocusSectorName = result.list2
              .map((sector: any) => sector.focusSectorName) // Extract focus sector names
              .join(', '); // Join names with commas

            
          }

          this.usr_object = {
            status: result.status,
            message: result.message,
            //list1: result.list1.length > 0 ? [result.list1[0]] : [],
            //list2: result.list2,
            list3: result.list3,
            list4: result.list4
          };
          //    this.selectedPairs.push(result?.list3);

          result.list3.forEach((item: { interventionId: any; interventionName: any; interestId: any; interestName: any; }) => {
            this.selectedPairs.push({
              interventionId: item.interventionId || null,
              interventionName: item.interventionName || '',
              interestId: item.interestId || '',
              interestName: item.interestName || ''
            });
          });

          result?.list4?.forEach((item: { spocName: string; spocDesignation: string; spocEmail: string; spocMobile: string }) => {
            this.spocList.push({
              spocName: item.spocName || '',
              spocDesignation: item.spocDesignation || '',
              spocEmail: item.spocEmail || '',
              spocMobile: item.spocMobile || ''
            });
          });

          //result?.list2?.forEach((item: { focusSectorName: string; focusSectorId: string; }) => {
          //  this.selectedFocusSectorIds.push({
          //    focusSectorName: item.focusSectorName || '',
          //    focusSectorId: item.focusSectorId || '',

          //  });
          //});

          // Extract existing focus sectors
          this.existingFocusSectorIds = result.list2.map((sector: any) => Number(sector.focusSectorId)); // IDs from API
          //const existingFocusSectorNames = result.list2.map((sector: any) => sector.focusSectorName); // Names from API

          //// Merge existing and new focus sector IDs
          //const newFocusSectorIds = this.selectedFocusSector || []; // New IDs selected by the user
          //const allFocusSectorIds = [...new Set([...existingFocusSectorIds, ...newFocusSectorIds])];

          //// Merge existing and new focus sector names
          //let newFocusSectorNames = this.selectedFocusSectorName || []; // New names selected by the user
          //let allFocusSectorNames = [...new Set([...existingFocusSectorNames, ...newFocusSectorNames])];

          //this.form.controls.focusSectorId.setValue(allFocusSectorIds.join(',')); // Convert to comma-separated string
          //this.form.controls.focusSectorName.setValue(allFocusSectorNames.join(',')); // Convert to comma-separated string




          //this.FocusSectorName = this.data[1]

          //  .map((sector:any) => sector.focusSectorName).join(', ');

          this.FocusSectorName = result.list2
            .map((sector: any) => sector.focusSectorName) // Extract focusSectorName from each item in list2
            .join(', ');

          //let arr = this.data[1];
          //for (let index in arr) {
          //  this.FocusSectorName=arr[index];  // Access each element by index
          //}

          this.IndustryAssociationId = result.list1[0]['industryAssociationId'];

          this.GetIaOrganisationalInformation(this.IndustryAssociationId);

        }
      }
    );
  }



  get f() {
    return this.form2.controls;
  }
  get f1() {
    return this.form.controls;
  }
  get storeFields(): FormArray {

    return this.form2.get('storeFields') as FormArray;

  }

  formatContactNumber(event: any): void {
    let input = event.target.value.replace(/\D/g, ''); // Remove non-numeric characters
    if (input.length > 3 && input.length <= 6) {
      input = input.replace(/^(\d{3})(\d+)/, '$1-$2'); // Format as XXX-XXX
    } else if (input.length > 6) {
      input = input.replace(/^(\d{3})(\d{3})(\d+)/, '$1-$2-$3'); // Format as XXX-XXX-XXXX
    }
    event.target.value = input; // Update the input field value
  }
  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  //numberAndCapitalAlphabetsOnly(event: any): boolean {
  //  const charCode = event.which ? event.which : event.keyCode;

  //  // Allow numbers (0-9) and capital alphabets (A-Z)
  //  if ((charCode >= 48 && charCode <= 57) || // Numbers
  //    (charCode >= 65 && charCode <= 90)) { // Capital letters
  //    return true;
  //  }

  //  // Block all other characters
  //  return false;
  //}
  numberAndCapitalAlphabetsOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;

    // Allow numbers (0-9), uppercase letters (A-Z), and lowercase letters (a-z)
    if (
      (charCode >= 48 && charCode <= 57) || // Numbers
      (charCode >= 65 && charCode <= 90) || // Uppercase letters
      (charCode >= 97 && charCode <= 122) // Lowercase letters
    ) {
      // If the input is a lowercase letter, convert it to uppercase
      if (charCode >= 97 && charCode <= 122) {
        event.target.value += String.fromCharCode(charCode).toUpperCase();
        event.preventDefault(); // Prevent adding the original lowercase letter
      }
      return true;
    }

    // Block all other characters
    return false;
  }
  numberanddashOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 45) {
      return false;
    }
    return true;
  }
  textOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122)) {
      return false;
    }
    return true;
  }
  textAndSpaceOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;

    // Allow letters (A-Z, a-z) and space (ASCII 32)
    if ((charCode >= 65 && charCode <= 90) || // Uppercase letters
      (charCode >= 97 && charCode <= 122) || // Lowercase letters
      charCode === 32) { // Space
      return true;
    }

    // Block all other characters
    return false;
  }
  textSpaceCommaOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;

    // Allow letters (A-Z, a-z), space (ASCII 32), comma (ASCII 44), full stop (ASCII 46), and hyphen (ASCII 45)
    if (
      (charCode >= 65 && charCode <= 90) || // Uppercase letters
      (charCode >= 97 && charCode <= 122) || // Lowercase letters
      charCode === 32 || // Space
      charCode === 44 || // Comma
      charCode === 46 || // Full stop
      charCode === 45 // Hyphen
    ) {
      return true;
    }

    // Block all other characters
    return false;
  }


  onIALogoFileSelected(event: Event): void {
    
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length) {
      this.ialogoFile = input.files[0];

      // Reset file errors
      this.IalogoErrors = { typeError: false, sizeError: false };

      // Check file type (only images like jpg, png)
      const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      if (!validTypes.includes(this.ialogoFile.type)) {
        this.IalogoErrors.typeError = true;
      }

      // Check file size (maxSizeInMB limit)
      const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
      if (this.ialogoFile.size > maxSizeInBytes) {
        this.IalogoErrors.sizeError = true;
      }

      // Set file name in form if validation passes
      if (!this.IalogoErrors.typeError && !this.IalogoErrors.sizeError) {
        this.form2.patchValue({
          iaLogoName: this.ialogoFile.name
        });
        this.form2.get('ialogoFile')?.markAsTouched();
        this.form2.get('ialogoFile')?.markAsDirty();

        const file = this.ialogoFile;
        if (file) {
          const reader = new FileReader();
          reader.onload = (e: any) => {
            this.ialogoUrl = e.target.result; // Show selected file as a preview
          };
          reader.readAsDataURL(file);
        }


      } else {
        this.form2.patchValue({
          iaLogoName: null
        });
      }
    }

  }



  onSaveClick(form: any) { }

  navigatetopage() {
    sessionStorage.setItem('readonlyUsername', JSON.stringify(this.iaUserName));
    sessionStorage.setItem('singInAs', 'IAUserName');
    this.router.navigateByUrl("/changepassword");

  }

  Logout() {
    sessionStorage.clear();
    this.router.navigateByUrl("/login");
  }

  onReset() {
    this.form2.reset();
    sessionStorage.clear();
  }

  prepareFormData(): FormData {
    const formData = new FormData();

    Object.keys(this.form2.value).forEach(key => {
      const value = this.form2.get(key)?.value;
      if (value !== null) {
        formData.append(key, value);
      }

    });


    // Append the file separately
    if (this.ialogoFile) {
      formData.append('ialogoFile', this.ialogoFile);  // Add the actual file
    }
    formData.append('industryAssociationId', this.IndustryAssociationId);
    return formData;
  }

  onSubmit() {
    this.isSubmitted = true;
    
    this.isEditable = false;
    //this.form2.get('bankName')?.disable();

    if (this.form2.valid && !this.IalogoErrors.typeError && !this.IalogoErrors.sizeError) {

      const formDatas = this.prepareFormData();



      this.apiService.postRequest(API_ENDPOINTS.IA.IAORGANISATIONINFORMATION, formDatas).subscribe(res => {


        alert("You have completed the profile,you can now create proposal");
        //this.router.navigateByUrl("/createnewproposal");
        this.router.navigateByUrl("/proposal");
      });
    }
    catchError(error => {
      let errorMessage = "An error occurred during login.";
      if (error.status === 409) {
        errorMessage = "User already exists";
      } else if (error.status === 400) {
        errorMessage = "Bad Request";
      }
      alert(errorMessage);
      return of(null);
    });
    this.form2.markAllAsTouched();
  }

  // Function to enable form editing
  enableEdit() {
    this.isEditable = true;
    this.form2.get('bankName')?.enable();
    this.form2.get('email')?.enable();
  }


  //toggleEdit() {
  //  this.isEditable = !this.isEditable;
  //}

  updateEdit() {
    //this.isSubmitted = true;
    this.isEditable = true;
    //is.IsProfileCompleted = false;
    // Bind the updated data back to the form group



    if (this.form2.valid && !this.IalogoErrors.typeError && !this.IalogoErrors.sizeError) {

      const formDatas = this.prepareFormData();



      this.apiService.postRequest(API_ENDPOINTS.IA.UPDATEIAORGANISATIONINFORMATION, formDatas).subscribe(res => {


        //this.toastr.warning(res.message);
        alert(res.message);
        //alert("You have updated the profile,you can now create proposal");
        this.router.navigateByUrl("/proposal");
      });
    }
    catchError(error => {
      let errorMessage = "An error occurred during login.";
      if (error.status === 409) {
        errorMessage = "User already exists";
      } else if (error.status === 400) {
        errorMessage = "Bad Request";
      }
      alert(errorMessage);
      return of(null);
    });

  }

  async loadInterventions(): Promise<void> {
    try {
      const data = await this.apiService.getRequest(API_ENDPOINTS.MASTERS.INTERVENTION.GETLIST).toPromise();
      if (data.data && Array.isArray(data.data)) {
        this.interventions = data.data;
      } else {
        console.error('Unexpected data structure:', data);
      }
    } catch (error) {
      console.error('Error fetching interventions:', error);
    }
  };
  async loadInterests(): Promise<void> {
    try {
      const data = await this.apiService.getRequest(API_ENDPOINTS.MASTERS.INTEREST.GETLIST).toPromise();
      if (data.data && Array.isArray(data.data)) {
        this.interests = data.data;
      } else {
        console.error('Unexpected data structure:', data);
      }
    } catch (error) {
      console.error('Error fetching interests:', error); // Handle error
    }
  };

  onInterventionChange(event: any): void {
    const interventionId = event.target.value;
    this.filteredInterests = this.interests.filter(interest =>
      interest.interventionId == interventionId
    );
  }

  addPair(): void {
    const interventionId = this.form.get('Intervention')?.value;
    const interestId = this.form.get('InterestsId')?.value;

    // Check if both fields are selected
    if (!interventionId) {
      alert('Please select an intervention.');
      return;
    }

    if (!interestId) {
      alert('Please select an interest.');
      return;
    }

    if (interventionId && interestId) {
      const selectedIntervention = this.interventions.find(type => type.interventionId == interventionId);
      const selectedInterest = this.interests.find(type => type.interestId == interestId);

      if (selectedIntervention && selectedInterest) {
        // Check for duplicates
        const duplicate = this.selectedPairs.some(pair =>
          pair.interventionId === selectedIntervention.interventionId &&
          pair.interestId === selectedInterest.interestId
        );

        if (!duplicate) {
          // Check intervention type for max interest limit
          const isCapacityBuilding = selectedIntervention.interventionName === 'Capacity Building';
          const maxInterests = isCapacityBuilding ? 3 : Infinity; // Set limit based on intervention type

          // Count current interests for the selected intervention
          const currentCount = this.selectedPairs.filter(pair => pair.interventionId === selectedIntervention.interventionId).length;

          if (isCapacityBuilding && currentCount >= maxInterests) {
            alert('You can only add a maximum of 3 interests for Capacity Building.');
          } else {
            this.selectedPairs.push({
              interventionId: selectedIntervention.interventionId,
              interventionName: selectedIntervention.interventionName,
              interestId: selectedInterest.interestId,
              interestName: selectedInterest.interestName,
            });
            this.resetSelection();
          }
        } else {
          alert('This intervention and interest pair already exists.');
        }
      }
    }
  }
  add(): void {

    if (this.form.controls.SpocName.value && this.form.controls.SpocDesignation.value && this.form.controls.SpocEmail.value && this.form.controls.SpocMobile.value && this.isSpocOTPVerified == true) {
      // Add the form values to the records array only if the form is valid


      this.spocList.push({
        spocName: this.form.controls.SpocName.value,
        spocDesignation: this.form.controls.SpocDesignation.value,
        spocEmail: this.form.controls.SpocEmail.value,
        spocMobile: this.form.controls.SpocMobile.value

      });
      this.editingIndex = null;
      //this.form.reset();



      // Reset the form after adding the record
      this.resetSpocSelection();

      this.isButtonSpocMobileDisabled = false;
      this.mobileSpocOtpTimerRunning = false;



      // Reset the form after adding the record
      this.resetSpocSelection();
      this.form.controls['spocmobotp'].enable();


    }
    this.isSpocOTPVerified = false;
    this.form.get('spocmobotp')?.reset();


    this.form.controls.spocmobotp.markAllAsTouched();
    return;





  }
  resetSpocSelection(): void {
    this.form.get('SpocName')?.reset();
    this.form.get('SpocDesignation')?.reset();
    this.form.get('SpocEmail')?.reset();
    this.form.get('SpocMobile')?.reset();
    this.form.get('spocmobotp')?.reset();

    this.filteredInterests = [];
  }


  resetSelection(): void {
    this.form.get('Intervention')?.setValue('');
    this.form.get('InterestsId')?.setValue('');
    this.filteredInterests = [];
  }
  removePair(index: number): void {
    this.selectedPairs.splice(index, 1);
  }
  removeSpoc(index: number): void {
    // Confirm removal
    if (confirm("Are you sure you want to remove this SPOC?")) {
      // Remove the SPOC from the spocList array at the specified index
      this.spocList.splice(index, 1);
    }
  }
  editSpoc(index: number) {
    //this.editingIndex = index; // Save the index of the record being edited
    //const selectedSpoc = this.spocList[index];
    //this.form.patchValue(selectedSpoc); // Populate form with the selected record's data
    //this.spocList.splice(index, 1);

    // this.isButtonMobileDisabled = false;
    /*this.isSpocOTPVerified = true;*/
    this.isButtonSpocMobileDisabled = false;
    this.mobileSpocOtpTimerRunning = false;
    this.mobileSpocOtpTimer = 300;
    // Enable the button


    this.editingIndex = index;
    const spoc = this.spocList[index];
    this.form.patchValue({
      SpocName: spoc.spocName,
      SpocDesignation: spoc.spocDesignation,
      SpocEmail: spoc.spocEmail,
      SpocMobile: spoc.spocMobile,
    });

    // Mark the record as edited
    spoc.isEdited = true;

    this.form.get('spocmobotp')?.reset(); // Clear the SpocMobile field


    this.spocList.splice(index, 1);
  }

  startSpocMobileOtpTimer() {
    this.mobileSpocOtpTimerRunning = true;
    this.mobileSpocOtpTimer = 300;
    this.resendSpocMobileOtpDisabled = true;  // Disable resend while timer is running

    const spocmobileTimer = setInterval(() => {
      if (this.mobileSpocOtpTimer > 0) {
        this.mobileSpocOtpTimer--;
      } else {
        clearInterval(spocmobileTimer);
        this.mobileSpocOtpTimerRunning = false;
        this.resendSpocMobileOtpDisabled = false;  // Enable resend after timer ends
      }
    }, 1000);
  }

  SendSpocOTP() {
    this.form.controls['SpocMobile'].markAsTouched();
    if (this.form.controls.SpocMobile.invalid) {
      //alert('Please enter a valid mobile number.');
      return;
    }
    //this.isButtonDisabled = true;
    //this.isButtonMobileDisabled = true; // Disable "Send Mobile OTP" button
    this.isButtonSpocMobileDisabled = true; // Disable the Mobile Resend OTP button


    this.isSpocOTPVerified = false;
    this.form.controls['spocmobotp'].enable(); // Ensure FormControl is enabled
    const otpdata =
    {
      otpType: 'mobile',
      otpValue: this.form.controls.SpocMobile.value
    }
    this.apiService.postRequest(API_ENDPOINTS.Otp.SendOtp, otpdata).subscribe(
      res => {
        if (res.status) {
          this.toastr.success(res.message);
          this.mobileOtpSent = true;
          this.isVerifySpocMobileOtpButtonDisabled = false;  // Enable Verify button after OTP sent
          this.startSpocMobileOtpTimer();
          //this.startMobileOtpTimer();

          ////this.startResendCountdown();
          //this.isButtonMobileDisabled = true; // Re-enable if there's an error
          ////this.isButtonDisabled = true;
        }
        else {
          alert('Entered Mobile OTP is incorrect. Please enter correct OTP');
          //this.isButtonDisabled = false;
          this.isButtonSpocMobileDisabled = false; // Re-enable if there's an error
        }
      });
  }

  ReSendSpocMobileOTP() {
    if (!this.form.controls.SpocMobile.valid) {
      //alert('Please enter a valid mobile number.');
      return;
    }

    if (this.mobileResendCount >= this.maxResendAttempts) {
      this.toastr.warning('You have reached the maximum resend attempts for mobile OTP today.', 'Warning');
      //alert('You have reached the maximum resend attempts for mobile OTP today.');
      return;
    }

    this.mobileResendCount++;
    this.isButtonMobileDisabled = true; // Disable resend button until request complet
    //this.isButtonDisabled = true;

    const otpdata = {
      otpType: 'mobile',
      otpValue: this.form.controls.SpocMobile.value
    };

    this.apiService.postRequest(API_ENDPOINTS.Otp.SendOtp, otpdata).subscribe(res => {
      if (res.status) {
        this.resetCountdown(); // Restart the countdown for mobile OTP
        this.startSpocMobileOtpTimer(); // Start the mobile OTP timer after resend
        //this.isButtonDisabled = false;
      } else {
        alert('Error... Please try after sometime!!');
        this.isButtonMobileDisabled = false; // Re-enable if there's an error
      }
    });
  }
  verifySpocMobileOtp() {
    const otpdata = {
      OtpType: 'mobile',
      OtpValue: this.form.controls.SpocMobile.value,
      Otp: this.form.controls.spocmobotp.value?.toString()
    };

    this.apiService.postRequest(API_ENDPOINTS.Otp.VerifyOtp, otpdata).subscribe(
      (res) => {
        /*if (res.status)*/
        if (res.message === "OTP verified successfully.") {
          this.toastr.success(res.message);
          this.otpError = false;
          this.otpSuccess = true;
          this.stopCountdown();
          /*this.mobileSpocOtpTimer = 300;//if verified even after 5 minthe resend otp button will be disabled*/
          // Mark the OTP field as readonly
          this.isOTPVerified = true;
          this.form.controls.spocmobotp.disable(); // Disable the field to make it readonly
          //this.isResendButtonDisabled = true; //if verified even after 1 minute resend otp button will be disabled */
          this.isSpocOTPVerified = true; //for spoc
        } else {
          this.otpError = true;
          this.otpSuccess = false;
        }
      },
      (error) => {
        console.error('Error during mobile OTP verification:', error);
        this.toastr.error("Entered Mobile OTP is incorrect. Please enter correct OTP");
        this.otpError = true;
        this.otpSuccess = false;
      }
    );
  }

  resetCountdown() {
    this.stopCountdown();
    this.startResendCountdown();
  }
  stopCountdown() {
    this.countdownSubject.next();
    this.isResendButtonDisabled = false;
    this.countdownDisplay = '';
  }
  startResendCountdown() {
    this.isResendButtonDisabled = true;
    this.countdown = 300; // 300-second countdown
    interval(1000).pipe(takeUntil(this.countdownSubject)).subscribe(() => {
      if (this.countdown > 0) {
        this.countdown--;
        this.updateCountdownDisplay();
      } else {
        this.stopCountdown();
      }
    });
  }
  updateCountdownDisplay() {
    const minutes = Math.floor(this.countdown / 60);
    const seconds = this.countdown % 60;
    this.countdownDisplay = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }



  textandspecialcharsOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122) && (charCode < 32 || charCode > 47)) {
      return false;
    }
    return true;
  }

  combinedList() {
    // Tagging each source with a "source" property to differentiate them
    const selectedPairsWithSource = this.selectedPairs?.map(pair => ({
      ...pair,
      source: 'selectedPairs'
    })) || [];

    const usrList3WithSource = this.usr_object?.list3?.map(interest => ({
      ...interest,
      source: 'usr_list3'
    })) || [];

    // Concatenate both arrays
    return [...selectedPairsWithSource, ...usrList3WithSource];
  }

  prepareFormDataIA(): FormData {
    const formData = new FormData();

    Object.keys(this.form.value).forEach(key => {
      const value = this.form.get(key)?.value;
      if (value !== null) {
        formData.append(key, value);
      }

    });
    //const IndustryAssociationId = sessionStorage.getItem('iauserid');

    //formData.append('RegistrationId', this.form.controls.registrationId);
    return formData;
  }

  EditIA() {

    this.isEditable = true;




    //if (this.form.valid && this.spocList.length >= 1 && this.selectedPairs.length >= 1) {

    //  const formDatas = this.prepareFormDataIA();



    //  this.apiService.updateRequest(API_ENDPOINTS.IA.UPDATEIAUSERPROFILE, formDatas).subscribe(res => {


    //    //this.toastr.warning(res.message);
    //    alert(res.message);
    //    //alert("You have updated the profile,you can now create proposal");
    //    this.router.navigateByUrl("/proposal");
    //  });
    //}

    if (this.form.controls.addressOfOrganisation.valid && this.form.controls.nameOfOrganisation.valid && this.form.controls.contactNumber.valid && this.form.controls.mobileNumber.valid && this.spocList.length >= 1 && this.selectedPairs.length >= 1) {

      //const formdatavalue = {
      //  ...this.formData,
      //  ...this.getFormValuesIncludingDisabled(),
      //  iaUserInterests: this.selectedPairs,
      //  iaRegistrationSpocDetails: this.spocList,
      //};

      // this.form.controls.focusSectorId.setValue(this.selectedFocusSector?.join(','));
      //this.form.controls.focusSectorName.setValue(this.selectedFocusSectorName?.join(','));



      // Merge existing and new focus sector IDs
      const newFocusSectorIds = this.selectedFocusSector || []; // New IDs selected by the user
      this.allFocusSectorIds = [...new Set([...this.existingFocusSectorIds, ...newFocusSectorIds])]; // Proper merging and deduplication

      // Set the merged values in the form
      this.form.controls.focusSectorId.setValue(this.allFocusSectorIds.join(','));
      //this.form.controls.focusSectorName.setValue(this.allFocusSectorNames.join(','));

      const formdatavalue = {
        ...this.formData,
        ...this.getFormValuesIncludingDisabled(),
        iaUserInterests: this.selectedPairs,
        iaRegistrationSpocDetails: this.spocList,

        focusSectorId: this.form.controls.focusSectorId.value, // Merged IDs
        //focusSectorName: this.form.controls.focusSectorName.value // Merged names

      };


      this.apiService.postRequest(API_ENDPOINTS.IA.UPDATEIAUSERPROFILE, formdatavalue).subscribe(res => {
        alert(res.message);
        this.router.navigateByUrl("/proposal");
      });

    }
    catchError(error => {
      let errorMessage = "An error occurred during login.";
      if (error.status === 409) {
        errorMessage = "User already exists";
      } else if (error.status === 400) {
        errorMessage = "Bad Request";
      }
      alert(errorMessage);
      return of(null);
    });

  }
  getFormValuesIncludingDisabled() {
    const formValues = this.form.getRawValue();
    return formValues;
  }

  async LoadFocusSector() {
    try {
      const data = await this.apiService.getRequest(API_ENDPOINTS.FOCUSSECTOR.GETFOCUSSECTOR).toPromise();
      if (Array.isArray(data)) {
        this.focusSector = data;
      } else if (data.data && Array.isArray(data.data)) {
        this.focusSector = data.data;
      } else {
        console.error('Unexpected data structure:', data);
      }
    } catch (error) {
      console.error('Error fetching focus sectors:', error); // Handle error
    }



  };
  //onFocusSectorChange(event: any) {
  //  const focusSectorid = event.target.value;
  //  const focusSectorName = event.target.name;
  //  const isChecked = event.target.checked;

  //  if (isChecked) {
  //    if (!this.selectedFocusSector.includes(focusSectorid)) {
  //      this.selectedFocusSector.push(focusSectorid);
  //      this.selectedFocusSectorName.push(focusSectorName);
  //    }


  //  } else {
  //    const index = this.selectedFocusSector.indexOf(focusSectorid);
  //    if (index > -1) {
  //      this.selectedFocusSector.splice(index, 1);
  //    }
  //  }
  //}
  onFocusSectorChange(event: Event, focusSectorId: string, focusSectorName: string) {
    const inputElement = event.target as HTMLInputElement;
    const isChecked = inputElement.checked;

    if (isChecked) {
      if (!this.selectedFocusSector.includes(focusSectorId)) {
        this.selectedFocusSector.push(focusSectorId);
        this.selectedFocusSectorName.push(focusSectorName);
      }
    } else {
      const index = this.selectedFocusSector.indexOf(focusSectorId);
      if (index > -1) {
        this.selectedFocusSector.splice(index, 1);
        this.selectedFocusSectorName.splice(index, 1);
      }
    }
  }
  
  navigateBack() {
    this.router.navigate(['/mssidcdashboard']);
  }

}

